import * as types from '../index';

export const dynamicFieldsListAction = (data) => {
    return {
    type: types.DYNAMIC_FIELDS_LIST,
    data
    }
};

export const dynamicFieldsUpdateAction = (data) => { 
    return {
    type: types.DYNAMIC_FIELDS_UPDATE,
    data
    }
};

export const dynamicFieldsDataSaveAction = (data) => { 
    return {
    type: types.DYNAMIC_FIELDS_DATA_SAVE,
    data
    }
};

export const dynamicFieldsMasterListAction = (data) => {
    return {
    type: types.DYNAMIC_FIELDS_MASTER_LIST,
    data
    }
};

